import React, { useEffect, useState } from "react";
// import CultureMinistryLogo from "../../assets/images/culture_ministry_logo.svg";
import CultureMinistryLogo from "../../assets/images/mn_logo.png";
import HeydarAliyevCenterLogo from "../../assets/images/heydar_aliyev_center_logo.svg";
import EducationMinistryLogo from "../../assets/images/education_ministry_logo.svg";
import KidsArtFestLogo from "../../assets/images/kids_art_fest_logo.svg";
import Logo from "../../assets/images/kids_art_fest_logo_3.png";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import styles from "./index.module.css";
import registrationCheck from "../../api/registrationCheck";
import Loading from "../../components/loading";

const RegistrationCheckDetails = () => {
  // const [name, setName] = useState(null);
  // const [code, setCode] = useState(null);
  // const [nomination, setNomination] = useState(null);
  // const [city, setCity] = useState(null);
  // const [day, setDay] = useState(null);
  // const [time, setTime] = useState(null);
  // const [location, setLocation] = useState(null);
  // const [number, setNumber] = useState(null);
  const [data, setData] = useState(false);
  const [message, setMessage] = useState(null)
  const [loading, setLoading] = useState(true);

  const pdfHandler = () => {
    const divToDisplay = document.getElementById("pdf");
    html2canvas(divToDisplay).then(function (canvas) {
      const divImage = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        unit: "px",
        format: [canvas.width, canvas.height],
        compress: true,
      });
      pdf.addImage(divImage, "PNG", 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height);
      pdf.save(`${data?.ad_soyad}.pdf`);
    });
  };
  useEffect(() => {
    const userData = JSON.parse(sessionStorage?.userData);
    setMessage(userData.message)
    setData(userData)
  }, []);
  return (
    <>
      {loading ? (
        <>
          <div className={styles["wrapper"]} id="pdf">
            <div className={styles["inner-container"]}>
              <header className={styles["header"]}>
                <div className={styles["logo"]}>
                  <img src={Logo} alt="" />
                </div>
              </header>
              {data?.vaxt ? <>
                <h2 className={styles["title"]}>
                  İştirak məlumatları və qaydaları
                </h2>
                <main className={styles["main"]}>
                  <div>
                    <p>Ad, Soyad</p>
                    <p>{data?.ad_soyad}</p>
                  </div>
                  <div>
                    <p>İştirakçı kodu</p>
                    <p>{data?.kod}</p>
                  </div>
                  <div>
                    <p>Qeydiyyatdan keçdiyi rayon/şəhər</p>
                    <p>{data?.rayon}</p>
                  </div>
                  <div>
                    <p>Nominasiya</p>
                    <p>{data?.nominasiya}</p>
                  </div>
                  <div>
                    <p>Müsabiqənin keçiriləcəyi gün</p>
                    <p>{data?.gun}</p>
                  </div>
                  <div>
                    <p>Vaxt</p>
                    <p>{data?.vaxt}</p>
                  </div>
                  <div>
                    <p>Məkan</p>
                    {data?.mekan ? (
                      <>
                        <div className={styles["text-right-div"]}>
                          <p>{data?.mekan[0]}</p>
                          <p>{data?.mekan[1]}</p>
                        </div>
                      </>
                    ) : (
                      <p></p>
                    )}
                  </div>
                  <div>
                    <p>Məlumat üçün əlaqə nömrəsi </p>
                    {/* <p>{data?.nomre}</p> */}
                    <p>147</p>
                  </div>
                </main>
                <footer>
                  <h3 className={styles["h3"]}>İştirak qaydaları:</h3>
                  <ol className={styles["ol"]}>
                    <li>
                      İştirakçılar müsabiqə vaxtından 15 dəqiqə əvvəl müsabiqə
                      məkanına gəlməlidirlər.
                    </li>
                    <li>
                      İştirakçılar müsabiqə məkanına gəldikdə özləri ilə bu
                      formanı kağız və ya elektron formatda, eləcə də
                      şəxsiyyətlərini təsdiq edən sənədi (şəxsiyyət vəsiqəsi və ya
                      doğum haqqında şəhadatnamə) gətirməlidirlər.
                    </li>
                    <li>
                      Müsabiqədə iştirak çərçivəsində, həmçinin gözləmə zamanı
                      ümumi etik qaydalara riayət olunmalıdır. Müsabiqə keçirilən
                      məkanda digər iştirakçılara maneçilik törətməmək məqsədilə
                      yüksək səslə danışmaq, gülmək, məşq etmək qadağandır.
                    </li>
                  </ol>
                </footer>
              </> : <p className={styles["title"]} style={{ marginBottom: 40 }}>{message}</p>}
            </div>
          </div>
          {data?.vaxt && <div className={styles["download-container"]}>
            <div className={styles["next-container"]}>
              <button
                type="button"
                className={styles["next"]}
                onClick={() => pdfHandler()}
              >
                Faylı yüklə
              </button>
            </div>
          </div>}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default RegistrationCheckDetails;
